export default __webpack_public_path__ + "static/media/icon-customer-loyalty.19e8a63c.svg";